import { render, staticRenderFns } from "./DashboContra.vue?vue&type=template&id=14ba4ab1"
import script from "./DashboContra.js?vue&type=script&lang=js&external"
export * from "./DashboContra.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports